import { render, staticRenderFns } from "./MDteacher.vue?vue&type=template&id=7bba8c83&scoped=true"
import script from "./MDteacher.vue?vue&type=script&lang=js"
export * from "./MDteacher.vue?vue&type=script&lang=js"
import style0 from "./MDteacher.vue?vue&type=style&index=0&id=7bba8c83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bba8c83",
  null
  
)

export default component.exports